import { ReactNode } from "react";

type Props = {
  children: ReactNode;
};

export default function PcBody({ children }: Props) {
  return (
    <div className="relative w-[67.1875rem] h-[44.375rem] rounded-tl-[1.5rem] rounded-tr-[1.5rem] overflow-hidden">
      {children}
    </div>
  );
}
